import _implicitStylesheets from "./toolbarButtonMenu.css";

import _implicitScopedStylesheets from "./toolbarButtonMenu.scoped.css?scoped=true";

import _lightningMenuItem from "lightning/menuItem";
import _lightningButtonMenu from "lightning/buttonMenu";
import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, k: api_key, c: api_custom_element, i: api_iterator, h: api_element} = $api;
  const {_m0, _m1} = $ctx;
  return [api_element("div", {
    classMap: {
      "container": true
    },
    key: 0
  }, [api_custom_element("lightning-button-menu", _lightningButtonMenu, {
    props: {
      "alternativeText": $cmp.label,
      "iconName": $cmp.iconName,
      "menuAlignment": "auto"
    },
    key: 1,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleClick))
    }
  }, api_iterator($cmp.menuItems, function (menuItem) {
    return api_custom_element("lightning-menu-item", _lightningMenuItem, {
      props: {
        "value": menuItem.value,
        "label": menuItem.label
      },
      key: api_key(2, menuItem.value),
      on: {
        "click": _m1 || ($ctx._m1 = api_bind($cmp.menuItemClick))
      }
    }, []);
  }))])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "zpaper-toolbarButtonMenu_toolbarButtonMenu"
